import { useFormikContext, Formik, Form } from 'formik';
import { navigate, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useEffect } from 'react';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { has } from 'lodash';
import { stringify } from 'qs';
import 'react-intl';

React.createContext(200);

var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const isInternalTarget = (target) => typeof target === "undefined" || target === "" || target === "_self";
const isRelative = (url) => (url == null ? void 0 : url.startsWith("#")) || (url == null ? void 0 : url.startsWith("?")) || Boolean(url == null ? void 0 : url.match(/^\/(?!\/)/));
function hasChildren(input) {
  return has(input, "children");
}
function isText(input) {
  return has(input, "data");
}
const slugify = (...args) => {
  const value = args.join(" ");
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[^a-z0-9 ]/g, "").replace(/\s+/g, "-");
};
function FormikChanges({
  onChange
}) {
  const { values } = useFormikContext();
  useEffect(() => {
    onChange(values);
  }, [values, onChange]);
  return null;
}
function FormikInitialValues({
  useInitialValues
}) {
  const { touched, setFieldTouched, setFieldValue } = useFormikContext();
  const values = useInitialValues();
  useEffect(() => {
    if (values) {
      for (const field in values) {
        if (!touched[field]) {
          setFieldValue(field, values[field], false);
          setFieldTouched(field, true, false);
        }
      }
    }
  }, [touched, setFieldTouched, setFieldValue, values]);
  return null;
}
const isElement = (node) => Array.isArray(node.children);
function nodeToText(input) {
  return input.map((node) => {
    if (isText(node)) {
      return node.data.trim();
    }
    if (hasChildren(node)) {
      return nodeToText(node.children);
    }
    return "";
  }).join(" ");
}
const htmlParserOptions = (buildLink, classNames) => ({
  replace: (node) => {
    if (isElement(node)) {
      const { attribs, children, tagName } = node;
      const props = attributesToProps(attribs);
      const className = classNames == null ? void 0 : classNames[node.name];
      const addedClass = typeof className === "string" ? className : typeof className === "function" ? className(node) : void 0;
      if (addedClass) {
        props["className"] = [props["className"], addedClass].filter((c) => !!c).join(" ");
      }
      switch (tagName) {
        case "li": {
          const text = domToReact(children, htmlParserOptions(buildLink, classNames));
          return /* @__PURE__ */ React.createElement("li", __spreadValues$1({}, props), /* @__PURE__ */ React.createElement("div", null, text));
        }
        case "h2": {
          const text = domToReact(children, htmlParserOptions(buildLink, classNames));
          return /* @__PURE__ */ React.createElement("h2", __spreadProps$1(__spreadValues$1({}, props), {
            id: props.id || slugify(nodeToText(children))
          }), text);
        }
        case "a": {
          const Link = buildLink(props);
          return /* @__PURE__ */ React.createElement(Link, __spreadValues$1({}, props), domToReact(children, htmlParserOptions(buildLink, classNames)));
        }
        default: {
          return addedClass ? React.createElement(node.name, props, domToReact(children, htmlParserOptions(buildLink, classNames))) : void 0;
        }
      }
    }
  }
});
const buildHtmlBuilder = (buildLink) => (input) => {
  const Element2 = function MockHtml({ classNames }) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, parse(input, htmlParserOptions(buildLink, classNames)));
  };
  Element2.initialHtmlString = input;
  return Element2;
};
const isTruthy = (i) => Boolean(i);
const stripSlashes = (segment, index) => {
  if (index === 0) {
    return segment === "/" ? segment : segment.replace(/^\/{2,}/g, "/").replace(/\/+$/g, "");
  }
  return segment.replace(/^\/+|\/+$/g, "");
};
const buildUrl = (segments, query, queryOptions, fragment) => {
  const url = segments ? segments.filter(isTruthy).map(stripSlashes).join("/").replace(/^\/+/, "/") : "";
  const queryString = stringify(query, __spreadValues$1({
    skipNulls: true
  }, queryOptions));
  return [
    [url || "", queryString === "" ? null : queryString].filter((i) => typeof i === "string").join("?"),
    fragment
  ].filter(isTruthy).join("#");
};
const buildUrlBuilder = (segments, query, queryOptions, fragment) => (queryOverride, fragmentOverride) => buildUrl(segments, __spreadValues$1(__spreadValues$1({}, query || {}), queryOverride || {}), queryOptions, fragmentOverride || fragment);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function buildLink(_a) {
  var _b = _a, {
    href,
    segments,
    query,
    queryOptions,
    target
  } = _b, props = __objRest(_b, [
    "href",
    "segments",
    "query",
    "queryOptions",
    "target"
  ]);
  const buildUrl = buildUrlBuilder(segments || [href], query, queryOptions);
  const Element = function GatsbyLinkBuilder({
    className,
    activeClassName,
    children,
    query: queryOverride,
    fragment
  }) {
    const uri = buildUrl(queryOverride, fragment);
    return uri && isInternalTarget(target) && isRelative(uri) ? /* @__PURE__ */ React.createElement(Link, __spreadValues({
      to: uri,
      target,
      className,
      activeClassName
    }, props), children) : /* @__PURE__ */ React.createElement("a", __spreadValues({
      className,
      target: target || "_blank",
      rel: props.rel || (isRelative(uri) ? void 0 : "noreferrer"),
      href: uri
    }, props), children);
  };
  Element.navigate = (opts) => {
    const uri = buildUrl(opts == null ? void 0 : opts.query, opts == null ? void 0 : opts.fragment);
    navigate(uri, props);
  };
  Element.href = buildUrl();
  return Element;
}
const isGatsbyImageProps = (props) => {
  return !props.src;
};
const buildImage = (props) => {
  var _a;
  const Element = function GatsbyImageBuilder({ className }) {
    if (isGatsbyImageProps(props)) {
      return /* @__PURE__ */ React.createElement(GatsbyImage, __spreadProps(__spreadValues({}, props), {
        className
      }));
    } else {
      const _a2 = props, { width, height } = _a2, rest = __objRest(_a2, ["width", "height"]);
      return /* @__PURE__ */ React.createElement("div", {
        style: {
          width: "100%",
          position: "relative",
          paddingBottom: `${height / width * 100}%`
        }
      }, /* @__PURE__ */ React.createElement("img", __spreadProps(__spreadValues({}, rest), {
        style: {
          display: "block",
          width: "100%",
          position: "absolute",
          top: 0,
          left: 0
        },
        className
      })));
    }
  };
  Element.src = isGatsbyImageProps(props) ? (_a = props.image.images.fallback) == null ? void 0 : _a.src : props.src;
  return Element;
};
const buildHtml = buildHtmlBuilder(buildLink);
function buildForm(_c) {
  var _d = _c, {
    onChange,
    useInitialValues
  } = _d, formikProps = __objRest(_d, [
    "onChange",
    "useInitialValues"
  ]);
  return function GatsbyFormBuilder(_a) {
    var _b = _a, { children } = _b, formProps = __objRest(_b, ["children"]);
    return /* @__PURE__ */ React.createElement(Formik, __spreadValues({
      onSubmit: (values) => {
        console.log("form submission:", values);
      }
    }, formikProps), /* @__PURE__ */ React.createElement(Form, __spreadValues({}, formProps), onChange ? /* @__PURE__ */ React.createElement(FormikChanges, {
      onChange
    }) : null, useInitialValues ? /* @__PURE__ */ React.createElement(FormikInitialValues, {
      useInitialValues
    }) : null, children));
  };
}

export { buildForm, buildHtml, buildImage, buildLink };
